(function () {
    'use strict';

    angular
        .module('cloudApp')
        .service('InstanceActionService', InstanceActionService);

    InstanceActionService.$inject = ['$http'];

    function InstanceActionService($http) {

        this.startInstance = function startInstance(instanceId) {
            return $http.post(SERVER_API_URL+'api/instances/' + instanceId + '/start')
        };

        this.markSentReq = function startInstance(instanceId) {
            return $http.post(SERVER_API_URL+'api/instances/' + instanceId + '/req')
        };
    }
})();
